import { ResourceOptions } from 'react-admin';
import { FaChartLine } from 'react-icons/fa';
import { Resources } from '../../resource';

export { default as list } from './List';

export const name = Resources.blindBoxTradingTiers;
export const icon = FaChartLine;
export const options: ResourceOptions = {
  label: 'module.blindBox.tradingTiers',
};
